import { render } from "./groupbarchart.vue?vue&type=template&id=353f67b0&scoped=true"
import script from "./groupbarchart.vue?vue&type=script&lang=js"
export * from "./groupbarchart.vue?vue&type=script&lang=js"

import "./groupbarchart.vue?vue&type=style&index=0&id=353f67b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353f67b0"]])

export default __exports__